import type { FC } from 'react';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { Collapse } from '@mui/material';

import { useTranslationResponse } from '@isomorphic/hooks/use-translation-response';
import type { NavigationProps } from '../../Navigation';
import { NavActiveTitle, NavPanel, NavScroll, NavWrapper } from '../../Navigation.styles';
import { NavTree } from '../NavTree/NavTree';
import { ThemeSwitcher } from '../ThemeSwitcher/ThemeSwitcher';

export const NavigationCollapsible: FC<Omit<NavigationProps, 'resizable'>> = ({ navTree, activeDocMeta }) => {
  const router = useRouter();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const toggleOpenNav = (): void => setIsOpen((isOpen: boolean) => !isOpen);

  useEffect(() => {
    setIsOpen(false);
  }, [router.asPath]);

  return (
    <NavWrapper id="collapsible_navbar">
      <NavActiveTitle onClick={toggleOpenNav} className={isOpen ? 'collapsed' : ''}>
        {useTranslationResponse(activeDocMeta?.title || activeDocMeta?.navTitle, 'navigation')}
      </NavActiveTitle>
      <Collapse in={isOpen}>
        <NavScroll $scrolled>
          <NavPanel>
            <NavTree isOpened navTree={navTree} activeDocMeta={activeDocMeta} />
          </NavPanel>
          <ThemeSwitcher />
        </NavScroll>
      </Collapse>
    </NavWrapper>
  );
};
